import { intersection } from 'lodash';
import { BuildingTypes, BuildingTypesWithAbstractFlat } from '../components/search_filters/building_types';
import { AbstractFlatSearchConfig, SearchConfig } from '../containers/search_block/search_config';
import { IBuildingTypes, IBuildingTypesConfig } from '../models/filters/building_types';
import { IMainPage } from '../models/mainpage';
import { ISearchConfig } from '../models/search';
import { IStore } from '../models/store';

/*
  0: Контрольная группа
  1: Селектор с выбранным "Во вторичке" по умолчанию и старым гео-саджестом
  2: Селектор с выбранным "В категории" по умолчанию и старым гео-саджестом
  3: Старый селектор и новый гео-саджест
*/

export const experimentSections = ['index', 'sale'];

export const getABNewbuildingsSearchGroup = (mainpage: IMainPage): number => {
  const abNewbuildingsSearchExperiment =
    mainpage.experiments &&
    mainpage.experiments.find((experiment: { name: string; abGroup: number; }) =>
      experiment.name === 'mainpage_newbuilding_search');

  return abNewbuildingsSearchExperiment ? abNewbuildingsSearchExperiment.abGroup : 0;
};

export const getNewbuildingsGeosuggestEnabled = (mainpage: IMainPage) => {
  const abGroup = getABNewbuildingsSearchGroup(mainpage);

  // если группа 3, то влючаем поиск по ЖК
  return abGroup === 3;
};

const abstractFlatTypeFromBuildingType = (buildingTypes: string[]): string[] => {
  if (intersection(['new_flat', 'secondary_flat'], buildingTypes).length) {
    return ['flat'];
  }

  return buildingTypes;
};

export const getFiltersConfiguration = (
  state: IStore,
  section: string,
): {
  buildingType: IBuildingTypes;
  actualBuildingType: IBuildingTypes;
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
} => {
  let searchConfig = SearchConfig;
  let buildingType = state.buildingType;
  let buildingTypes = BuildingTypes;

  if (experimentSections.includes(section)) {
    // подмена new_flat и secondary_flat на flat для первого дропдауна
    // при наличии отдельного дропдауна выбора типа квартиры
    buildingType = {
      buildingType: abstractFlatTypeFromBuildingType(state.buildingType.buildingType),
      isDirty: false,
    };

    // вынесение типов "квартира во вторичке" "квартира в новостройке"
    // для первого дропдауна при наличии отдельного дропдауна выбора типа квартиры
    buildingTypes = BuildingTypesWithAbstractFlat;

    // показ дропдауна выбора типа квартиры
    // для типа сделки "купить" и трех типов квартир (общая / в новостройке / во вторичке)
    searchConfig = AbstractFlatSearchConfig;
  }

  return {
    actualBuildingType: state.buildingType,
    buildingType,
    buildingTypes,
    searchConfig,
  };
};
